export default "__VITE_ASSET__GQLQTHRe__"